import { forwardRef, InjectionToken, Type } from '@angular/core';

export interface StorageService {

  write(key: string, value: any);

  read<T>(key: string): T;

  remove(...keys: string[]);

}

export const StorageServiceToken = new InjectionToken<StorageService>('storageService');

interface StorageServiceProvider<T> {
  provide: InjectionToken<StorageService>;
  useExisting: Type<T>;
  multi: boolean;
}

export function storageServiceProvider<T extends StorageService>(type: Type<T>): StorageServiceProvider<T> {
  return {
    provide: StorageServiceToken,
    useExisting: forwardRef(() => type),
    multi: false
  };
}
